import React from "react";
import HeroPoster from "./HeroPoster";

// Hero banners with order 3 (Admin -> Hero banners)
const Poster3 = () => <HeroPoster order={3} variant="poster" />;

export default Poster3;
